<template>

  <main class="container container-choose-route d-flex flex-column align-items-center">
    <RentComponent
        :with-driver="this.store.state.order.withDriver"
    />

    <CustomRouteWrapperComponent></CustomRouteWrapperComponent>
  </main>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {useStore} from "vuex";
import './chooseCustomRoute.scss';
import axios from "axios";
// @ts-ignore
import apiService from "../../services/apiService";
// @ts-ignore
import RentComponent from '../../components/Forms/Rent/RentComponent.vue';
// @ts-ignore
import CustomRouteWrapperComponent from "../../components/customRouteWrapper/CustomRouteWrapperComponent.vue";

export default defineComponent({
  name: 'ChooseCustomRoutePage',
  components: {
    CustomRouteWrapperComponent,
    RentComponent,
  },

  setup() {
    const store = useStore();

    return {
      store
    }
  },

  data() {
    return {
    }
  },

  created() {
    axios.get(apiService.pageChooseCustomRoutePageEndpoint())
        .then((response) => {
          this.store.dispatch('orderTrueDriverTravelObjectives/initializeTravelObjectives', response.data.travelObjectives);
        });
  },
});
</script>
